import { useContext } from 'react'
import { FormContext } from '../FormProvider'
import { FormFieldProps, FormSwitchType } from './type'
import { Switch } from '@/components/ui/switch'

export const FormSwitchField = ({
  data,
  field,
}: FormFieldProps<FormSwitchType>) => {
  const context = useContext(FormContext)

  return (
    <div className="flex py-1">
      <Switch
        disabled={data.readOnly}
        checked={field.value}
        onCheckedChange={field.onChange}
      />
    </div>
  )
}
